import React, {useContext, useEffect, useState} from 'react';
import styles from './EledoConnections.module.scss';
import {
  EledoMainPageTitle, EledoPendingContent,
  EledoLoader, EledoError
} from "components/library";
import {showNotyf, useErrorNotyf, usePagination, useShowMenu} from "hooks";
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import classnames from 'classnames';
import {fetchConnections, forgetConnection, validateConnection} from "_reducers/connectionsReducer";
import NotyfContext from "context/NotyfContext";
import {useConfirmModal} from "hooks";
import { PlatformContext } from 'PlatformContext';
import useEledoConnections from 'graphql/hooks/useConnections';
import { ITEMS_PER_PAGE } from 'utils';

const EledoConnections = () => {
  const platform = useContext(PlatformContext);
  const isEmbedded = platform.isEmbedded;

  const [selectedPage, setSelectedPage] = useState(1)
  const { loading, error, connections, total } = useEledoConnections({page: selectedPage, limit: ITEMS_PER_PAGE})
  const renderPagination = usePagination(selectedPage, total, (newPage) => setSelectedPage(newPage))

  useErrorNotyf(error)
  useShowMenu();

  const renderError = () =>
    <EledoError title={error?.message}
                description={(<React.Fragment>
                  We are sorry &#9785; We could not load your connections. <br/><br/>
                  {error.message.toLocaleLowerCase() === "network error" && "Please check your internet connection."}
                </React.Fragment>)}/>;

  return (
    <div className={styles.EledoConnections} data-testid="EledoConnections">
      <EledoMainPageTitle
        title="Connections"
        subtitle="Manage your connected apps and view connection status."
        image="IllustrationsConnectionsCurved-03.svg"
      />

      { error && renderError() }
      {!error &&
        <div className="section my-content-section" style={{paddingTop: 0}}>
          { renderPagination() }
          <div className="container">
            <div className={classnames("w-layout-grid", "header-grid", styles.headerGrid)}>
              <div className="_wf-table-cell">
                <div>Type</div>
              </div>
              <div className="_wf-table-cell">
                <div>Description</div>
              </div>
              <div className="_wf-table-cell">
                <div>Status</div>
              </div>
              <div className="_wf-table-cell">
                <div>Actions</div>
              </div>
            </div>
            <EledoPendingContent state={loading}
                                 content={<ConnectionsTable connections={connections}/>}
                                 pendingContent={<div className="flex-center"><EledoLoader/></div>}
                                 showPendingIcon={false}
            />
          </div>
          { renderPagination() }
        </div>
      }

      { !isEmbedded && false &&
        <div className="section my-content-section">
          <div className="container" style={{paddingTop: "1rem"}}>
            <div className="template-menu-wrap"/>
            <h3>Add Connection:</h3>
            {renderAddConnection()}
          </div>
        </div>
      }

    </div>
  );
}

const ConnectionsTable = ({connections}) => {
  const platform = useContext(PlatformContext);
  const isEmbedded = platform.isEmbedded;
  const dispatch = useDispatch();
  const notyf = useContext(NotyfContext);

  if(connections && connections.length === 0) {
    return <div className="flex-center my-section">You have no connections yet.</div>;
  }

  const tileClass = classnames("tile-title", styles.tileTitle);
  const imageUrls = connections.map(c => getConnectionImageUrl(c.type));

  return connections ? connections.map((conn, index) => (
    <div className={classnames("w-layout-grid", "data-grid", styles.dataGrid, {"red": conn.status !== "VALID"})} key={conn.id}>
      <div className="_wf-table-cell">
        <div className={tileClass}>Type</div>
        { imageUrls[index] ?
            <div><img className="integration-logo" alt="monday logo" loading="lazy"
                    src={imageUrls[index]}/></div> :
            conn.type
        }
      </div>
      <div className="_wf-table-cell">
        <div className={tileClass}>Description</div>
        <div>
          { conn.description }
        </div>
      </div>
      <div className="_wf-table-cell">
        <div className={tileClass}>Status</div>
        <div>
          { conn.status }
        </div>
      </div>
      <div className="_wf-table-cell">
        <div className={tileClass}>Actions</div>
        <div>
          {/* <button style={{marginRight: "6px"}}
                  className="button outline w-button"
                  onClick={() => handleValidate(conn)}>
            <EledoPendingContent state={validating}
                                 content="Validate"
                                 pendingContent="Validating..."/>
          </button>
          { !isEmbedded &&
            <button className="button outline red w-button"
                    onClick={() => {
                      setSelectedConnection(conn);
                      setModalDisplayed(true);
                    }}>
              <EledoPendingContent state={forgetting}
                                   content="Forget"
                                   pendingContent="Forgetting..."/>
            </button>
          } */}
        </div>
      </div>
    </div>)) : null;
}


const renderAddConnection = () =>
  <div className="integrations-tabs w-tab-menu">
    <a className="integration-item w-inline-block w-tab-link"
       href="https://eledo.online/connections">
      <img className="integration-logo" loading="lazy"
           src={getConnectionImageUrl("MONDAY")}
           alt="Add to monday.com"/>
    </a>
    <a className="integration-item w-inline-block w-tab-link"
       href="https://eledo.online/connections/new/Tadabase">
      <img className="integration-logo" loading="lazy"
           src={getConnectionImageUrl("TADABASE")}
           alt="Add to tadabase.io"/>
    </a>
  </div>;

const getConnectionImageUrl = (connectionType) => {
  let image = "";
  switch(connectionType?.toLocaleUpperCase()) {
    case "MONDAY": image = "monday-logo-unified-01.svg"; break;
    case "TADABASE": image = "tadabase.png"; break;
    default: return null;
  }
  return `${process.env.PUBLIC_URL}/assets/images/connections/${image}`;
}

export default EledoConnections;
